import { helper } from '@ember/component/helper';

/**
 * Formats screaming snake case or kebab case as title case, retaining word content for already
 * readable values.
 */
export function humanize(value: string): string {
  if (!value) return '';

  return value
    .replace(/[_-]/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export default helper(function ([value]: [string]) {
  return humanize(value);
});
